import React from 'react';
import { motion } from 'framer-motion';
import { Printer, Shirt, PenTool, Layers, ArrowRight } from 'lucide-react';
const services = [{
  id: 'dtf',
  title: 'DTF Transfers',
  description: 'High-quality direct-to-film transfers ready to press on any fabric. Vibrant colors, soft hand feel, and extreme durability.',
  icon: Layers,
  image: 'https://images.unsplash.com/photo-1618331835717-801e976710b2?q=80&w=1000&auto=format&fit=crop'
}, {
  id: 'screen',
  title: 'Screen Printing',
  description: 'Traditional plastisol and water-based screen printing for bulk orders. The industry standard for retail-quality apparel.',
  icon: Printer,
  image: 'https://images.unsplash.com/photo-1603251579431-8041402bdeda?q=80&w=1000&auto=format&fit=crop'
}, {
  id: 'embroidery',
  title: 'Embroidery',
  description: 'Premium threading for hats, polos, and jackets. Professional, long-lasting branding with high thread counts.',
  icon: PenTool,
  image: 'https://images.unsplash.com/photo-1618423771880-22a8b9219148?q=80&w=1000&auto=format&fit=crop'
}, {
  id: 'apparel',
  title: 'Custom Apparel',
  description: 'Full-service sourcing and production. We handle everything from blank selection to finishing and bagging.',
  icon: Shirt,
  image: 'https://images.unsplash.com/photo-1529374255404-311a2a4f1fd9?q=80&w=1000&auto=format&fit=crop'
}];
export function ServicesGrid() {
  return <section id="services" className="py-24 bg-atomic-charcoal relative" data-id="element-172">
      <div className="container mx-auto px-4 md:px-6" data-id="element-173">
        <div className="flex flex-col md:flex-row justify-between items-end mb-16 gap-6" data-id="element-174">
          <div data-id="element-175">
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-176">
              Our Production Services
            </h2>
            <p className="text-gray-400 max-w-xl text-lg" data-id="element-177">
              Industrial-grade decoration methods for every project type.
            </p>
          </div>
          <a href="#" className="text-atomic-green font-medium hover:text-white transition-colors flex items-center gap-2 group" data-id="element-178">
            View full pricing{' '}
            <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" data-id="element-179" />
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-180">
          {services.map((service, index) => <motion.div key={service.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} whileHover={{
          y: -5
        }} className="group relative h-[400px] bg-atomic-dark rounded-xl overflow-hidden cursor-pointer border border-white/5 hover:border-atomic-green/50 transition-colors" data-id="element-181">
              {/* Background Image */}
              <div className="absolute inset-0" data-id="element-182">
                <img src={service.image} alt={service.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110 opacity-40 group-hover:opacity-20" data-id="element-183" />
                <div className="absolute inset-0 bg-gradient-to-t from-atomic-black via-atomic-black/80 to-transparent" data-id="element-184" />
              </div>

              {/* Content */}
              <div className="absolute inset-0 p-6 flex flex-col justify-end" data-id="element-185">
                <div className="mb-4 p-3 bg-atomic-green/10 w-fit rounded-lg text-atomic-green border border-atomic-green/20 group-hover:bg-atomic-green group-hover:text-black transition-colors" data-id="element-186">
                  <service.icon size={24} data-id="element-187" />
                </div>
                <h3 className="text-2xl font-bold text-white mb-2" data-id="element-188">
                  {service.title}
                </h3>
                <p className="text-gray-400 text-sm mb-4 line-clamp-3 group-hover:text-gray-300 transition-colors" data-id="element-189">
                  {service.description}
                </p>
                <div className="flex items-center text-atomic-green font-medium text-sm group-hover:text-white transition-colors" data-id="element-190">
                  Learn More{' '}
                  <ArrowRight className="ml-2 w-4 h-4 transition-transform group-hover:translate-x-1" data-id="element-191" />
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}